export class PoliticaPeticion {
    codCliente: string = "-1";
    idPerfil: string = "-1";
}